import ImageCollectionPage from "../components/ImageCollectionPage";

export default function Music() {
  return <ImageCollectionPage title="Music" path="/culture/music" collection="culture_music" />;
}
